import BaseController from './basePlayerController';
import { OP_WRAPPER_LOCALIZATION_PREFIX } from '../../../utils/constants';

export default class ControllerBet extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });
    this._eElementsTypes = {
      EET_LABEL: 'label',
      EET_VALUE: 'value',
    };
    this._localizations = {
      [this._eElementsTypes.EET_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.userInterface.bet_label`,
    };
    this._adaptiveElements = [this._eElementsTypes.EET_LABEL, this._eElementsTypes.EET_VALUE];

    this._availableBets = [];
    this._currentBetIndex = -1;
    this.init(container);
  }

  setBets(availableBets) {
    this._availableBets = availableBets;
  }

  setCurrentBetIndex(index) {
    if (index < 0 || index >= this._availableBets.length) return;
    this._currentBetIndex = index;
    this.set(this._eElementsTypes.EET_VALUE, this._moneyFormat(this._availableBets[index]));
  }

  get maxIndex() {
    return this._availableBets.length - 1;
  }

  _getMarkup() {
    return `
          <div class="ui-container__title-desc-col ui-container__bet_container">
            <label id=${this.interactiveElementsIds[this._eElementsTypes.EET_LABEL]}>
              ${this._getLocalization(this._localizations[this._eElementsTypes.EET_LABEL])}
            </label>
            <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_VALUE]}>
              0.12345678
            </span>
          </div>`
  }
}
